// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-shadow */
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
  /**
   * 8 bytes signed integer
   *
   */
  Int8: any;
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: any;
}

export interface Account {
  __typename?: 'Account';
  id: Scalars['ID'];
  address: Scalars['Bytes'];
  numAssets: Scalars['Int'];
  ownedAssets?: Maybe<AccountAsset[]>;
  createdAssets?: Maybe<Asset[]>;
}

export interface AccountOwnedAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountAsset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountAsset_Filter>;
}

export interface AccountCreatedAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Asset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Asset_Filter>;
}

export interface AccountAsset {
  __typename?: 'AccountAsset';
  id: Scalars['ID'];
  asset: Asset;
  quantity: Scalars['Int'];
  account: Account;
}

export interface AccountAsset_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_not?: Maybe<Scalars['Int']>;
  quantity_gt?: Maybe<Scalars['Int']>;
  quantity_lt?: Maybe<Scalars['Int']>;
  quantity_gte?: Maybe<Scalars['Int']>;
  quantity_lte?: Maybe<Scalars['Int']>;
  quantity_in?: Maybe<Scalars['Int'][]>;
  quantity_not_in?: Maybe<Scalars['Int'][]>;
  account?: Maybe<Scalars['String']>;
  account_not?: Maybe<Scalars['String']>;
  account_gt?: Maybe<Scalars['String']>;
  account_lt?: Maybe<Scalars['String']>;
  account_gte?: Maybe<Scalars['String']>;
  account_lte?: Maybe<Scalars['String']>;
  account_in?: Maybe<Scalars['String'][]>;
  account_not_in?: Maybe<Scalars['String'][]>;
  account_contains?: Maybe<Scalars['String']>;
  account_contains_nocase?: Maybe<Scalars['String']>;
  account_not_contains?: Maybe<Scalars['String']>;
  account_not_contains_nocase?: Maybe<Scalars['String']>;
  account_starts_with?: Maybe<Scalars['String']>;
  account_starts_with_nocase?: Maybe<Scalars['String']>;
  account_not_starts_with?: Maybe<Scalars['String']>;
  account_not_starts_with_nocase?: Maybe<Scalars['String']>;
  account_ends_with?: Maybe<Scalars['String']>;
  account_ends_with_nocase?: Maybe<Scalars['String']>;
  account_not_ends_with?: Maybe<Scalars['String']>;
  account_not_ends_with_nocase?: Maybe<Scalars['String']>;
  account_?: Maybe<Account_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<AccountAsset_Filter>[]>;
  or?: Maybe<Maybe<AccountAsset_Filter>[]>;
}

export enum AccountAsset_OrderBy {
  Id = 'id',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
  Quantity = 'quantity',
  Account = 'account',
  AccountId = 'account__id',
  AccountAddress = 'account__address',
  AccountNumAssets = 'account__numAssets',
}

export interface AccountCollection {
  __typename?: 'AccountCollection';
  id: Scalars['ID'];
  collection: Collection;
  numAssets: Scalars['Int'];
  account: Account;
}

export interface AccountCollection_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  collection?: Maybe<Scalars['String']>;
  collection_not?: Maybe<Scalars['String']>;
  collection_gt?: Maybe<Scalars['String']>;
  collection_lt?: Maybe<Scalars['String']>;
  collection_gte?: Maybe<Scalars['String']>;
  collection_lte?: Maybe<Scalars['String']>;
  collection_in?: Maybe<Scalars['String'][]>;
  collection_not_in?: Maybe<Scalars['String'][]>;
  collection_contains?: Maybe<Scalars['String']>;
  collection_contains_nocase?: Maybe<Scalars['String']>;
  collection_not_contains?: Maybe<Scalars['String']>;
  collection_not_contains_nocase?: Maybe<Scalars['String']>;
  collection_starts_with?: Maybe<Scalars['String']>;
  collection_starts_with_nocase?: Maybe<Scalars['String']>;
  collection_not_starts_with?: Maybe<Scalars['String']>;
  collection_not_starts_with_nocase?: Maybe<Scalars['String']>;
  collection_ends_with?: Maybe<Scalars['String']>;
  collection_ends_with_nocase?: Maybe<Scalars['String']>;
  collection_not_ends_with?: Maybe<Scalars['String']>;
  collection_not_ends_with_nocase?: Maybe<Scalars['String']>;
  collection_?: Maybe<Collection_Filter>;
  numAssets?: Maybe<Scalars['Int']>;
  numAssets_not?: Maybe<Scalars['Int']>;
  numAssets_gt?: Maybe<Scalars['Int']>;
  numAssets_lt?: Maybe<Scalars['Int']>;
  numAssets_gte?: Maybe<Scalars['Int']>;
  numAssets_lte?: Maybe<Scalars['Int']>;
  numAssets_in?: Maybe<Scalars['Int'][]>;
  numAssets_not_in?: Maybe<Scalars['Int'][]>;
  account?: Maybe<Scalars['String']>;
  account_not?: Maybe<Scalars['String']>;
  account_gt?: Maybe<Scalars['String']>;
  account_lt?: Maybe<Scalars['String']>;
  account_gte?: Maybe<Scalars['String']>;
  account_lte?: Maybe<Scalars['String']>;
  account_in?: Maybe<Scalars['String'][]>;
  account_not_in?: Maybe<Scalars['String'][]>;
  account_contains?: Maybe<Scalars['String']>;
  account_contains_nocase?: Maybe<Scalars['String']>;
  account_not_contains?: Maybe<Scalars['String']>;
  account_not_contains_nocase?: Maybe<Scalars['String']>;
  account_starts_with?: Maybe<Scalars['String']>;
  account_starts_with_nocase?: Maybe<Scalars['String']>;
  account_not_starts_with?: Maybe<Scalars['String']>;
  account_not_starts_with_nocase?: Maybe<Scalars['String']>;
  account_ends_with?: Maybe<Scalars['String']>;
  account_ends_with_nocase?: Maybe<Scalars['String']>;
  account_not_ends_with?: Maybe<Scalars['String']>;
  account_not_ends_with_nocase?: Maybe<Scalars['String']>;
  account_?: Maybe<Account_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<AccountCollection_Filter>[]>;
  or?: Maybe<Maybe<AccountCollection_Filter>[]>;
}

export enum AccountCollection_OrderBy {
  Id = 'id',
  Collection = 'collection',
  CollectionId = 'collection__id',
  CollectionTokenAddress = 'collection__tokenAddress',
  CollectionTotalSupply = 'collection__totalSupply',
  CollectionTotalOwners = 'collection__totalOwners',
  NumAssets = 'numAssets',
  Account = 'account',
  AccountId = 'account__id',
  AccountAddress = 'account__address',
  AccountNumAssets = 'account__numAssets',
}

export interface Account_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  address?: Maybe<Scalars['Bytes']>;
  address_not?: Maybe<Scalars['Bytes']>;
  address_gt?: Maybe<Scalars['Bytes']>;
  address_lt?: Maybe<Scalars['Bytes']>;
  address_gte?: Maybe<Scalars['Bytes']>;
  address_lte?: Maybe<Scalars['Bytes']>;
  address_in?: Maybe<Scalars['Bytes'][]>;
  address_not_in?: Maybe<Scalars['Bytes'][]>;
  address_contains?: Maybe<Scalars['Bytes']>;
  address_not_contains?: Maybe<Scalars['Bytes']>;
  numAssets?: Maybe<Scalars['Int']>;
  numAssets_not?: Maybe<Scalars['Int']>;
  numAssets_gt?: Maybe<Scalars['Int']>;
  numAssets_lt?: Maybe<Scalars['Int']>;
  numAssets_gte?: Maybe<Scalars['Int']>;
  numAssets_lte?: Maybe<Scalars['Int']>;
  numAssets_in?: Maybe<Scalars['Int'][]>;
  numAssets_not_in?: Maybe<Scalars['Int'][]>;
  ownedAssets_?: Maybe<AccountAsset_Filter>;
  createdAssets_?: Maybe<Asset_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Account_Filter>[]>;
  or?: Maybe<Maybe<Account_Filter>[]>;
}

export enum Account_OrderBy {
  Id = 'id',
  Address = 'address',
  NumAssets = 'numAssets',
  OwnedAssets = 'ownedAssets',
  CreatedAssets = 'createdAssets',
}

export enum Aggregation_Interval {
  Hour = 'hour',
  Day = 'day',
}

export interface Asset {
  __typename?: 'Asset';
  id: Scalars['ID'];
  tokenId: Scalars['Int'];
  tokenAddress: Scalars['Bytes'];
  totalSupply: Scalars['Int'];
  type?: Maybe<AssetType>;
  uri?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  searchTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  searchDescription?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  animation_url?: Maybe<Scalars['String']>;
  creator?: Maybe<Account>;
  commission?: Maybe<TokenCommission>;
  displayTime?: Maybe<Scalars['Int']>;
  listingPrices?: Maybe<ListingPrice[]>;
  nativePrice?: Maybe<Scalars['BigInt']>;
  mogulPrice?: Maybe<Scalars['BigInt']>;
  bids?: Maybe<Bid[]>;
  lastSoldPrice?: Maybe<TokenPrice>;
  mintedTime?: Maybe<Scalars['Int']>;
  numOwners?: Maybe<Scalars['Int']>;
  listings?: Maybe<Listing[]>;
  activeListings?: Maybe<Listing[]>;
  activeListingsLength?: Maybe<Scalars['Int']>;
  owners?: Maybe<AccountAsset[]>;
  histories?: Maybe<AssetHistory[]>;
}

export interface AssetListingPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ListingPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<ListingPrice_Filter>;
}

export interface AssetBidsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Bid_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Bid_Filter>;
}

export interface AssetListingsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Listing_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Listing_Filter>;
}

export interface AssetActiveListingsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Listing_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Listing_Filter>;
}

export interface AssetOwnersArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountAsset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountAsset_Filter>;
}

export interface AssetHistoriesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AssetHistory_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AssetHistory_Filter>;
}

export interface AssetHistory {
  __typename?: 'AssetHistory';
  id: Scalars['ID'];
  hash: Scalars['Bytes'];
  asset: Asset;
  type: AssetHistoryType;
  timestamp: Scalars['Int'];
  bid?: Maybe<Bid>;
  listing?: Maybe<Listing>;
  sale?: Maybe<Sale>;
  transfer?: Maybe<Transfer>;
}

export enum AssetHistoryType {
  Transfer = 'TRANSFER',
  Create = 'CREATE',
  AuctionStart = 'AUCTION_START',
  AuctionBid = 'AUCTION_BID',
  AuctionEnd = 'AUCTION_END',
  AuctionCancel = 'AUCTION_CANCEL',
  ListingStart = 'LISTING_START',
  ListingCancel = 'LISTING_CANCEL',
  ListingPriceChange = 'LISTING_PRICE_CHANGE',
  Sale = 'SALE',
}

export interface AssetHistory_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  hash?: Maybe<Scalars['Bytes']>;
  hash_not?: Maybe<Scalars['Bytes']>;
  hash_gt?: Maybe<Scalars['Bytes']>;
  hash_lt?: Maybe<Scalars['Bytes']>;
  hash_gte?: Maybe<Scalars['Bytes']>;
  hash_lte?: Maybe<Scalars['Bytes']>;
  hash_in?: Maybe<Scalars['Bytes'][]>;
  hash_not_in?: Maybe<Scalars['Bytes'][]>;
  hash_contains?: Maybe<Scalars['Bytes']>;
  hash_not_contains?: Maybe<Scalars['Bytes']>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  type?: Maybe<AssetHistoryType>;
  type_not?: Maybe<AssetHistoryType>;
  type_in?: Maybe<AssetHistoryType[]>;
  type_not_in?: Maybe<AssetHistoryType[]>;
  timestamp?: Maybe<Scalars['Int']>;
  timestamp_not?: Maybe<Scalars['Int']>;
  timestamp_gt?: Maybe<Scalars['Int']>;
  timestamp_lt?: Maybe<Scalars['Int']>;
  timestamp_gte?: Maybe<Scalars['Int']>;
  timestamp_lte?: Maybe<Scalars['Int']>;
  timestamp_in?: Maybe<Scalars['Int'][]>;
  timestamp_not_in?: Maybe<Scalars['Int'][]>;
  bid?: Maybe<Scalars['String']>;
  bid_not?: Maybe<Scalars['String']>;
  bid_gt?: Maybe<Scalars['String']>;
  bid_lt?: Maybe<Scalars['String']>;
  bid_gte?: Maybe<Scalars['String']>;
  bid_lte?: Maybe<Scalars['String']>;
  bid_in?: Maybe<Scalars['String'][]>;
  bid_not_in?: Maybe<Scalars['String'][]>;
  bid_contains?: Maybe<Scalars['String']>;
  bid_contains_nocase?: Maybe<Scalars['String']>;
  bid_not_contains?: Maybe<Scalars['String']>;
  bid_not_contains_nocase?: Maybe<Scalars['String']>;
  bid_starts_with?: Maybe<Scalars['String']>;
  bid_starts_with_nocase?: Maybe<Scalars['String']>;
  bid_not_starts_with?: Maybe<Scalars['String']>;
  bid_not_starts_with_nocase?: Maybe<Scalars['String']>;
  bid_ends_with?: Maybe<Scalars['String']>;
  bid_ends_with_nocase?: Maybe<Scalars['String']>;
  bid_not_ends_with?: Maybe<Scalars['String']>;
  bid_not_ends_with_nocase?: Maybe<Scalars['String']>;
  bid_?: Maybe<Bid_Filter>;
  listing?: Maybe<Scalars['String']>;
  listing_not?: Maybe<Scalars['String']>;
  listing_gt?: Maybe<Scalars['String']>;
  listing_lt?: Maybe<Scalars['String']>;
  listing_gte?: Maybe<Scalars['String']>;
  listing_lte?: Maybe<Scalars['String']>;
  listing_in?: Maybe<Scalars['String'][]>;
  listing_not_in?: Maybe<Scalars['String'][]>;
  listing_contains?: Maybe<Scalars['String']>;
  listing_contains_nocase?: Maybe<Scalars['String']>;
  listing_not_contains?: Maybe<Scalars['String']>;
  listing_not_contains_nocase?: Maybe<Scalars['String']>;
  listing_starts_with?: Maybe<Scalars['String']>;
  listing_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_not_starts_with?: Maybe<Scalars['String']>;
  listing_not_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_ends_with?: Maybe<Scalars['String']>;
  listing_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_not_ends_with?: Maybe<Scalars['String']>;
  listing_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_?: Maybe<Listing_Filter>;
  sale?: Maybe<Scalars['String']>;
  sale_not?: Maybe<Scalars['String']>;
  sale_gt?: Maybe<Scalars['String']>;
  sale_lt?: Maybe<Scalars['String']>;
  sale_gte?: Maybe<Scalars['String']>;
  sale_lte?: Maybe<Scalars['String']>;
  sale_in?: Maybe<Scalars['String'][]>;
  sale_not_in?: Maybe<Scalars['String'][]>;
  sale_contains?: Maybe<Scalars['String']>;
  sale_contains_nocase?: Maybe<Scalars['String']>;
  sale_not_contains?: Maybe<Scalars['String']>;
  sale_not_contains_nocase?: Maybe<Scalars['String']>;
  sale_starts_with?: Maybe<Scalars['String']>;
  sale_starts_with_nocase?: Maybe<Scalars['String']>;
  sale_not_starts_with?: Maybe<Scalars['String']>;
  sale_not_starts_with_nocase?: Maybe<Scalars['String']>;
  sale_ends_with?: Maybe<Scalars['String']>;
  sale_ends_with_nocase?: Maybe<Scalars['String']>;
  sale_not_ends_with?: Maybe<Scalars['String']>;
  sale_not_ends_with_nocase?: Maybe<Scalars['String']>;
  sale_?: Maybe<Sale_Filter>;
  transfer?: Maybe<Scalars['String']>;
  transfer_not?: Maybe<Scalars['String']>;
  transfer_gt?: Maybe<Scalars['String']>;
  transfer_lt?: Maybe<Scalars['String']>;
  transfer_gte?: Maybe<Scalars['String']>;
  transfer_lte?: Maybe<Scalars['String']>;
  transfer_in?: Maybe<Scalars['String'][]>;
  transfer_not_in?: Maybe<Scalars['String'][]>;
  transfer_contains?: Maybe<Scalars['String']>;
  transfer_contains_nocase?: Maybe<Scalars['String']>;
  transfer_not_contains?: Maybe<Scalars['String']>;
  transfer_not_contains_nocase?: Maybe<Scalars['String']>;
  transfer_starts_with?: Maybe<Scalars['String']>;
  transfer_starts_with_nocase?: Maybe<Scalars['String']>;
  transfer_not_starts_with?: Maybe<Scalars['String']>;
  transfer_not_starts_with_nocase?: Maybe<Scalars['String']>;
  transfer_ends_with?: Maybe<Scalars['String']>;
  transfer_ends_with_nocase?: Maybe<Scalars['String']>;
  transfer_not_ends_with?: Maybe<Scalars['String']>;
  transfer_not_ends_with_nocase?: Maybe<Scalars['String']>;
  transfer_?: Maybe<Transfer_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<AssetHistory_Filter>[]>;
  or?: Maybe<Maybe<AssetHistory_Filter>[]>;
}

export enum AssetHistory_OrderBy {
  Id = 'id',
  Hash = 'hash',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
  Type = 'type',
  Timestamp = 'timestamp',
  Bid = 'bid',
  BidId = 'bid__id',
  BidAmount = 'bid__amount',
  BidAuctionToken = 'bid__auctionToken',
  Listing = 'listing',
  ListingId = 'listing__id',
  ListingTest = 'listing__test',
  ListingListingId = 'listing__listingId',
  ListingQuantity = 'listing__quantity',
  ListingStartTime = 'listing__startTime',
  ListingEndTime = 'listing__endTime',
  ListingType = 'listing__type',
  ListingStatus = 'listing__status',
  ListingHighestBidAmount = 'listing__highestBidAmount',
  ListingHighestBidToken = 'listing__highestBidToken',
  Sale = 'sale',
  SaleId = 'sale__id',
  SaleAmount = 'sale__amount',
  SaleQuantity = 'sale__quantity',
  SaleAuctionToken = 'sale__auctionToken',
  Transfer = 'transfer',
  TransferId = 'transfer__id',
  TransferHash = 'transfer__hash',
  TransferQuantity = 'transfer__quantity',
}

export enum AssetType {
  Erc1155 = 'ERC1155',
  Erc721 = 'ERC721',
}

export interface Asset_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  tokenId?: Maybe<Scalars['Int']>;
  tokenId_not?: Maybe<Scalars['Int']>;
  tokenId_gt?: Maybe<Scalars['Int']>;
  tokenId_lt?: Maybe<Scalars['Int']>;
  tokenId_gte?: Maybe<Scalars['Int']>;
  tokenId_lte?: Maybe<Scalars['Int']>;
  tokenId_in?: Maybe<Scalars['Int'][]>;
  tokenId_not_in?: Maybe<Scalars['Int'][]>;
  tokenAddress?: Maybe<Scalars['Bytes']>;
  tokenAddress_not?: Maybe<Scalars['Bytes']>;
  tokenAddress_gt?: Maybe<Scalars['Bytes']>;
  tokenAddress_lt?: Maybe<Scalars['Bytes']>;
  tokenAddress_gte?: Maybe<Scalars['Bytes']>;
  tokenAddress_lte?: Maybe<Scalars['Bytes']>;
  tokenAddress_in?: Maybe<Scalars['Bytes'][]>;
  tokenAddress_not_in?: Maybe<Scalars['Bytes'][]>;
  tokenAddress_contains?: Maybe<Scalars['Bytes']>;
  tokenAddress_not_contains?: Maybe<Scalars['Bytes']>;
  totalSupply?: Maybe<Scalars['Int']>;
  totalSupply_not?: Maybe<Scalars['Int']>;
  totalSupply_gt?: Maybe<Scalars['Int']>;
  totalSupply_lt?: Maybe<Scalars['Int']>;
  totalSupply_gte?: Maybe<Scalars['Int']>;
  totalSupply_lte?: Maybe<Scalars['Int']>;
  totalSupply_in?: Maybe<Scalars['Int'][]>;
  totalSupply_not_in?: Maybe<Scalars['Int'][]>;
  type?: Maybe<AssetType>;
  type_not?: Maybe<AssetType>;
  type_in?: Maybe<AssetType[]>;
  type_not_in?: Maybe<AssetType[]>;
  uri?: Maybe<Scalars['String']>;
  uri_not?: Maybe<Scalars['String']>;
  uri_gt?: Maybe<Scalars['String']>;
  uri_lt?: Maybe<Scalars['String']>;
  uri_gte?: Maybe<Scalars['String']>;
  uri_lte?: Maybe<Scalars['String']>;
  uri_in?: Maybe<Scalars['String'][]>;
  uri_not_in?: Maybe<Scalars['String'][]>;
  uri_contains?: Maybe<Scalars['String']>;
  uri_contains_nocase?: Maybe<Scalars['String']>;
  uri_not_contains?: Maybe<Scalars['String']>;
  uri_not_contains_nocase?: Maybe<Scalars['String']>;
  uri_starts_with?: Maybe<Scalars['String']>;
  uri_starts_with_nocase?: Maybe<Scalars['String']>;
  uri_not_starts_with?: Maybe<Scalars['String']>;
  uri_not_starts_with_nocase?: Maybe<Scalars['String']>;
  uri_ends_with?: Maybe<Scalars['String']>;
  uri_ends_with_nocase?: Maybe<Scalars['String']>;
  uri_not_ends_with?: Maybe<Scalars['String']>;
  uri_not_ends_with_nocase?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_gt?: Maybe<Scalars['String']>;
  title_lt?: Maybe<Scalars['String']>;
  title_gte?: Maybe<Scalars['String']>;
  title_lte?: Maybe<Scalars['String']>;
  title_in?: Maybe<Scalars['String'][]>;
  title_not_in?: Maybe<Scalars['String'][]>;
  title_contains?: Maybe<Scalars['String']>;
  title_contains_nocase?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  title_not_contains_nocase?: Maybe<Scalars['String']>;
  title_starts_with?: Maybe<Scalars['String']>;
  title_starts_with_nocase?: Maybe<Scalars['String']>;
  title_not_starts_with?: Maybe<Scalars['String']>;
  title_not_starts_with_nocase?: Maybe<Scalars['String']>;
  title_ends_with?: Maybe<Scalars['String']>;
  title_ends_with_nocase?: Maybe<Scalars['String']>;
  title_not_ends_with?: Maybe<Scalars['String']>;
  title_not_ends_with_nocase?: Maybe<Scalars['String']>;
  searchTitle?: Maybe<Scalars['String']>;
  searchTitle_not?: Maybe<Scalars['String']>;
  searchTitle_gt?: Maybe<Scalars['String']>;
  searchTitle_lt?: Maybe<Scalars['String']>;
  searchTitle_gte?: Maybe<Scalars['String']>;
  searchTitle_lte?: Maybe<Scalars['String']>;
  searchTitle_in?: Maybe<Scalars['String'][]>;
  searchTitle_not_in?: Maybe<Scalars['String'][]>;
  searchTitle_contains?: Maybe<Scalars['String']>;
  searchTitle_contains_nocase?: Maybe<Scalars['String']>;
  searchTitle_not_contains?: Maybe<Scalars['String']>;
  searchTitle_not_contains_nocase?: Maybe<Scalars['String']>;
  searchTitle_starts_with?: Maybe<Scalars['String']>;
  searchTitle_starts_with_nocase?: Maybe<Scalars['String']>;
  searchTitle_not_starts_with?: Maybe<Scalars['String']>;
  searchTitle_not_starts_with_nocase?: Maybe<Scalars['String']>;
  searchTitle_ends_with?: Maybe<Scalars['String']>;
  searchTitle_ends_with_nocase?: Maybe<Scalars['String']>;
  searchTitle_not_ends_with?: Maybe<Scalars['String']>;
  searchTitle_not_ends_with_nocase?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_gt?: Maybe<Scalars['String']>;
  description_lt?: Maybe<Scalars['String']>;
  description_gte?: Maybe<Scalars['String']>;
  description_lte?: Maybe<Scalars['String']>;
  description_in?: Maybe<Scalars['String'][]>;
  description_not_in?: Maybe<Scalars['String'][]>;
  description_contains?: Maybe<Scalars['String']>;
  description_contains_nocase?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  description_not_contains_nocase?: Maybe<Scalars['String']>;
  description_starts_with?: Maybe<Scalars['String']>;
  description_starts_with_nocase?: Maybe<Scalars['String']>;
  description_not_starts_with?: Maybe<Scalars['String']>;
  description_not_starts_with_nocase?: Maybe<Scalars['String']>;
  description_ends_with?: Maybe<Scalars['String']>;
  description_ends_with_nocase?: Maybe<Scalars['String']>;
  description_not_ends_with?: Maybe<Scalars['String']>;
  description_not_ends_with_nocase?: Maybe<Scalars['String']>;
  searchDescription?: Maybe<Scalars['String']>;
  searchDescription_not?: Maybe<Scalars['String']>;
  searchDescription_gt?: Maybe<Scalars['String']>;
  searchDescription_lt?: Maybe<Scalars['String']>;
  searchDescription_gte?: Maybe<Scalars['String']>;
  searchDescription_lte?: Maybe<Scalars['String']>;
  searchDescription_in?: Maybe<Scalars['String'][]>;
  searchDescription_not_in?: Maybe<Scalars['String'][]>;
  searchDescription_contains?: Maybe<Scalars['String']>;
  searchDescription_contains_nocase?: Maybe<Scalars['String']>;
  searchDescription_not_contains?: Maybe<Scalars['String']>;
  searchDescription_not_contains_nocase?: Maybe<Scalars['String']>;
  searchDescription_starts_with?: Maybe<Scalars['String']>;
  searchDescription_starts_with_nocase?: Maybe<Scalars['String']>;
  searchDescription_not_starts_with?: Maybe<Scalars['String']>;
  searchDescription_not_starts_with_nocase?: Maybe<Scalars['String']>;
  searchDescription_ends_with?: Maybe<Scalars['String']>;
  searchDescription_ends_with_nocase?: Maybe<Scalars['String']>;
  searchDescription_not_ends_with?: Maybe<Scalars['String']>;
  searchDescription_not_ends_with_nocase?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_not?: Maybe<Scalars['String']>;
  image_gt?: Maybe<Scalars['String']>;
  image_lt?: Maybe<Scalars['String']>;
  image_gte?: Maybe<Scalars['String']>;
  image_lte?: Maybe<Scalars['String']>;
  image_in?: Maybe<Scalars['String'][]>;
  image_not_in?: Maybe<Scalars['String'][]>;
  image_contains?: Maybe<Scalars['String']>;
  image_contains_nocase?: Maybe<Scalars['String']>;
  image_not_contains?: Maybe<Scalars['String']>;
  image_not_contains_nocase?: Maybe<Scalars['String']>;
  image_starts_with?: Maybe<Scalars['String']>;
  image_starts_with_nocase?: Maybe<Scalars['String']>;
  image_not_starts_with?: Maybe<Scalars['String']>;
  image_not_starts_with_nocase?: Maybe<Scalars['String']>;
  image_ends_with?: Maybe<Scalars['String']>;
  image_ends_with_nocase?: Maybe<Scalars['String']>;
  image_not_ends_with?: Maybe<Scalars['String']>;
  image_not_ends_with_nocase?: Maybe<Scalars['String']>;
  animation_url?: Maybe<Scalars['String']>;
  animation_url_not?: Maybe<Scalars['String']>;
  animation_url_gt?: Maybe<Scalars['String']>;
  animation_url_lt?: Maybe<Scalars['String']>;
  animation_url_gte?: Maybe<Scalars['String']>;
  animation_url_lte?: Maybe<Scalars['String']>;
  animation_url_in?: Maybe<Scalars['String'][]>;
  animation_url_not_in?: Maybe<Scalars['String'][]>;
  animation_url_contains?: Maybe<Scalars['String']>;
  animation_url_contains_nocase?: Maybe<Scalars['String']>;
  animation_url_not_contains?: Maybe<Scalars['String']>;
  animation_url_not_contains_nocase?: Maybe<Scalars['String']>;
  animation_url_starts_with?: Maybe<Scalars['String']>;
  animation_url_starts_with_nocase?: Maybe<Scalars['String']>;
  animation_url_not_starts_with?: Maybe<Scalars['String']>;
  animation_url_not_starts_with_nocase?: Maybe<Scalars['String']>;
  animation_url_ends_with?: Maybe<Scalars['String']>;
  animation_url_ends_with_nocase?: Maybe<Scalars['String']>;
  animation_url_not_ends_with?: Maybe<Scalars['String']>;
  animation_url_not_ends_with_nocase?: Maybe<Scalars['String']>;
  creator?: Maybe<Scalars['String']>;
  creator_not?: Maybe<Scalars['String']>;
  creator_gt?: Maybe<Scalars['String']>;
  creator_lt?: Maybe<Scalars['String']>;
  creator_gte?: Maybe<Scalars['String']>;
  creator_lte?: Maybe<Scalars['String']>;
  creator_in?: Maybe<Scalars['String'][]>;
  creator_not_in?: Maybe<Scalars['String'][]>;
  creator_contains?: Maybe<Scalars['String']>;
  creator_contains_nocase?: Maybe<Scalars['String']>;
  creator_not_contains?: Maybe<Scalars['String']>;
  creator_not_contains_nocase?: Maybe<Scalars['String']>;
  creator_starts_with?: Maybe<Scalars['String']>;
  creator_starts_with_nocase?: Maybe<Scalars['String']>;
  creator_not_starts_with?: Maybe<Scalars['String']>;
  creator_not_starts_with_nocase?: Maybe<Scalars['String']>;
  creator_ends_with?: Maybe<Scalars['String']>;
  creator_ends_with_nocase?: Maybe<Scalars['String']>;
  creator_not_ends_with?: Maybe<Scalars['String']>;
  creator_not_ends_with_nocase?: Maybe<Scalars['String']>;
  creator_?: Maybe<Account_Filter>;
  commission?: Maybe<Scalars['String']>;
  commission_not?: Maybe<Scalars['String']>;
  commission_gt?: Maybe<Scalars['String']>;
  commission_lt?: Maybe<Scalars['String']>;
  commission_gte?: Maybe<Scalars['String']>;
  commission_lte?: Maybe<Scalars['String']>;
  commission_in?: Maybe<Scalars['String'][]>;
  commission_not_in?: Maybe<Scalars['String'][]>;
  commission_contains?: Maybe<Scalars['String']>;
  commission_contains_nocase?: Maybe<Scalars['String']>;
  commission_not_contains?: Maybe<Scalars['String']>;
  commission_not_contains_nocase?: Maybe<Scalars['String']>;
  commission_starts_with?: Maybe<Scalars['String']>;
  commission_starts_with_nocase?: Maybe<Scalars['String']>;
  commission_not_starts_with?: Maybe<Scalars['String']>;
  commission_not_starts_with_nocase?: Maybe<Scalars['String']>;
  commission_ends_with?: Maybe<Scalars['String']>;
  commission_ends_with_nocase?: Maybe<Scalars['String']>;
  commission_not_ends_with?: Maybe<Scalars['String']>;
  commission_not_ends_with_nocase?: Maybe<Scalars['String']>;
  commission_?: Maybe<TokenCommission_Filter>;
  displayTime?: Maybe<Scalars['Int']>;
  displayTime_not?: Maybe<Scalars['Int']>;
  displayTime_gt?: Maybe<Scalars['Int']>;
  displayTime_lt?: Maybe<Scalars['Int']>;
  displayTime_gte?: Maybe<Scalars['Int']>;
  displayTime_lte?: Maybe<Scalars['Int']>;
  displayTime_in?: Maybe<Scalars['Int'][]>;
  displayTime_not_in?: Maybe<Scalars['Int'][]>;
  listingPrices_?: Maybe<ListingPrice_Filter>;
  nativePrice?: Maybe<Scalars['BigInt']>;
  nativePrice_not?: Maybe<Scalars['BigInt']>;
  nativePrice_gt?: Maybe<Scalars['BigInt']>;
  nativePrice_lt?: Maybe<Scalars['BigInt']>;
  nativePrice_gte?: Maybe<Scalars['BigInt']>;
  nativePrice_lte?: Maybe<Scalars['BigInt']>;
  nativePrice_in?: Maybe<Scalars['BigInt'][]>;
  nativePrice_not_in?: Maybe<Scalars['BigInt'][]>;
  mogulPrice?: Maybe<Scalars['BigInt']>;
  mogulPrice_not?: Maybe<Scalars['BigInt']>;
  mogulPrice_gt?: Maybe<Scalars['BigInt']>;
  mogulPrice_lt?: Maybe<Scalars['BigInt']>;
  mogulPrice_gte?: Maybe<Scalars['BigInt']>;
  mogulPrice_lte?: Maybe<Scalars['BigInt']>;
  mogulPrice_in?: Maybe<Scalars['BigInt'][]>;
  mogulPrice_not_in?: Maybe<Scalars['BigInt'][]>;
  bids_?: Maybe<Bid_Filter>;
  lastSoldPrice?: Maybe<Scalars['String']>;
  lastSoldPrice_not?: Maybe<Scalars['String']>;
  lastSoldPrice_gt?: Maybe<Scalars['String']>;
  lastSoldPrice_lt?: Maybe<Scalars['String']>;
  lastSoldPrice_gte?: Maybe<Scalars['String']>;
  lastSoldPrice_lte?: Maybe<Scalars['String']>;
  lastSoldPrice_in?: Maybe<Scalars['String'][]>;
  lastSoldPrice_not_in?: Maybe<Scalars['String'][]>;
  lastSoldPrice_contains?: Maybe<Scalars['String']>;
  lastSoldPrice_contains_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_not_contains?: Maybe<Scalars['String']>;
  lastSoldPrice_not_contains_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_starts_with?: Maybe<Scalars['String']>;
  lastSoldPrice_starts_with_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_not_starts_with?: Maybe<Scalars['String']>;
  lastSoldPrice_not_starts_with_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_ends_with?: Maybe<Scalars['String']>;
  lastSoldPrice_ends_with_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_not_ends_with?: Maybe<Scalars['String']>;
  lastSoldPrice_not_ends_with_nocase?: Maybe<Scalars['String']>;
  lastSoldPrice_?: Maybe<TokenPrice_Filter>;
  mintedTime?: Maybe<Scalars['Int']>;
  mintedTime_not?: Maybe<Scalars['Int']>;
  mintedTime_gt?: Maybe<Scalars['Int']>;
  mintedTime_lt?: Maybe<Scalars['Int']>;
  mintedTime_gte?: Maybe<Scalars['Int']>;
  mintedTime_lte?: Maybe<Scalars['Int']>;
  mintedTime_in?: Maybe<Scalars['Int'][]>;
  mintedTime_not_in?: Maybe<Scalars['Int'][]>;
  numOwners?: Maybe<Scalars['Int']>;
  numOwners_not?: Maybe<Scalars['Int']>;
  numOwners_gt?: Maybe<Scalars['Int']>;
  numOwners_lt?: Maybe<Scalars['Int']>;
  numOwners_gte?: Maybe<Scalars['Int']>;
  numOwners_lte?: Maybe<Scalars['Int']>;
  numOwners_in?: Maybe<Scalars['Int'][]>;
  numOwners_not_in?: Maybe<Scalars['Int'][]>;
  listings_?: Maybe<Listing_Filter>;
  activeListings_?: Maybe<Listing_Filter>;
  activeListingsLength?: Maybe<Scalars['Int']>;
  activeListingsLength_not?: Maybe<Scalars['Int']>;
  activeListingsLength_gt?: Maybe<Scalars['Int']>;
  activeListingsLength_lt?: Maybe<Scalars['Int']>;
  activeListingsLength_gte?: Maybe<Scalars['Int']>;
  activeListingsLength_lte?: Maybe<Scalars['Int']>;
  activeListingsLength_in?: Maybe<Scalars['Int'][]>;
  activeListingsLength_not_in?: Maybe<Scalars['Int'][]>;
  owners_?: Maybe<AccountAsset_Filter>;
  histories_?: Maybe<AssetHistory_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Asset_Filter>[]>;
  or?: Maybe<Maybe<Asset_Filter>[]>;
}

export enum Asset_OrderBy {
  Id = 'id',
  TokenId = 'tokenId',
  TokenAddress = 'tokenAddress',
  TotalSupply = 'totalSupply',
  Type = 'type',
  Uri = 'uri',
  Title = 'title',
  SearchTitle = 'searchTitle',
  Description = 'description',
  SearchDescription = 'searchDescription',
  Image = 'image',
  AnimationUrl = 'animation_url',
  Creator = 'creator',
  CreatorId = 'creator__id',
  CreatorAddress = 'creator__address',
  CreatorNumAssets = 'creator__numAssets',
  Commission = 'commission',
  CommissionId = 'commission__id',
  CommissionArtistAddress = 'commission__artistAddress',
  CommissionCommissionBasisPoint = 'commission__commissionBasisPoint',
  DisplayTime = 'displayTime',
  ListingPrices = 'listingPrices',
  NativePrice = 'nativePrice',
  MogulPrice = 'mogulPrice',
  Bids = 'bids',
  LastSoldPrice = 'lastSoldPrice',
  LastSoldPriceId = 'lastSoldPrice__id',
  LastSoldPricePrice = 'lastSoldPrice__price',
  LastSoldPriceTokenAddress = 'lastSoldPrice__tokenAddress',
  MintedTime = 'mintedTime',
  NumOwners = 'numOwners',
  Listings = 'listings',
  ActiveListings = 'activeListings',
  ActiveListingsLength = 'activeListingsLength',
  Owners = 'owners',
  Histories = 'histories',
}

export interface Bid {
  __typename?: 'Bid';
  id: Scalars['ID'];
  bidder: Account;
  amount: Scalars['BigInt'];
  auctionToken: Scalars['String'];
  listing: Listing;
  asset: Asset;
}

export interface Bid_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  bidder?: Maybe<Scalars['String']>;
  bidder_not?: Maybe<Scalars['String']>;
  bidder_gt?: Maybe<Scalars['String']>;
  bidder_lt?: Maybe<Scalars['String']>;
  bidder_gte?: Maybe<Scalars['String']>;
  bidder_lte?: Maybe<Scalars['String']>;
  bidder_in?: Maybe<Scalars['String'][]>;
  bidder_not_in?: Maybe<Scalars['String'][]>;
  bidder_contains?: Maybe<Scalars['String']>;
  bidder_contains_nocase?: Maybe<Scalars['String']>;
  bidder_not_contains?: Maybe<Scalars['String']>;
  bidder_not_contains_nocase?: Maybe<Scalars['String']>;
  bidder_starts_with?: Maybe<Scalars['String']>;
  bidder_starts_with_nocase?: Maybe<Scalars['String']>;
  bidder_not_starts_with?: Maybe<Scalars['String']>;
  bidder_not_starts_with_nocase?: Maybe<Scalars['String']>;
  bidder_ends_with?: Maybe<Scalars['String']>;
  bidder_ends_with_nocase?: Maybe<Scalars['String']>;
  bidder_not_ends_with?: Maybe<Scalars['String']>;
  bidder_not_ends_with_nocase?: Maybe<Scalars['String']>;
  bidder_?: Maybe<Account_Filter>;
  amount?: Maybe<Scalars['BigInt']>;
  amount_not?: Maybe<Scalars['BigInt']>;
  amount_gt?: Maybe<Scalars['BigInt']>;
  amount_lt?: Maybe<Scalars['BigInt']>;
  amount_gte?: Maybe<Scalars['BigInt']>;
  amount_lte?: Maybe<Scalars['BigInt']>;
  amount_in?: Maybe<Scalars['BigInt'][]>;
  amount_not_in?: Maybe<Scalars['BigInt'][]>;
  auctionToken?: Maybe<Scalars['String']>;
  auctionToken_not?: Maybe<Scalars['String']>;
  auctionToken_gt?: Maybe<Scalars['String']>;
  auctionToken_lt?: Maybe<Scalars['String']>;
  auctionToken_gte?: Maybe<Scalars['String']>;
  auctionToken_lte?: Maybe<Scalars['String']>;
  auctionToken_in?: Maybe<Scalars['String'][]>;
  auctionToken_not_in?: Maybe<Scalars['String'][]>;
  auctionToken_contains?: Maybe<Scalars['String']>;
  auctionToken_contains_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_contains?: Maybe<Scalars['String']>;
  auctionToken_not_contains_nocase?: Maybe<Scalars['String']>;
  auctionToken_starts_with?: Maybe<Scalars['String']>;
  auctionToken_starts_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_starts_with?: Maybe<Scalars['String']>;
  auctionToken_not_starts_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_ends_with?: Maybe<Scalars['String']>;
  auctionToken_ends_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_ends_with?: Maybe<Scalars['String']>;
  auctionToken_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing?: Maybe<Scalars['String']>;
  listing_not?: Maybe<Scalars['String']>;
  listing_gt?: Maybe<Scalars['String']>;
  listing_lt?: Maybe<Scalars['String']>;
  listing_gte?: Maybe<Scalars['String']>;
  listing_lte?: Maybe<Scalars['String']>;
  listing_in?: Maybe<Scalars['String'][]>;
  listing_not_in?: Maybe<Scalars['String'][]>;
  listing_contains?: Maybe<Scalars['String']>;
  listing_contains_nocase?: Maybe<Scalars['String']>;
  listing_not_contains?: Maybe<Scalars['String']>;
  listing_not_contains_nocase?: Maybe<Scalars['String']>;
  listing_starts_with?: Maybe<Scalars['String']>;
  listing_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_not_starts_with?: Maybe<Scalars['String']>;
  listing_not_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_ends_with?: Maybe<Scalars['String']>;
  listing_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_not_ends_with?: Maybe<Scalars['String']>;
  listing_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_?: Maybe<Listing_Filter>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Bid_Filter>[]>;
  or?: Maybe<Maybe<Bid_Filter>[]>;
}

export enum Bid_OrderBy {
  Id = 'id',
  Bidder = 'bidder',
  BidderId = 'bidder__id',
  BidderAddress = 'bidder__address',
  BidderNumAssets = 'bidder__numAssets',
  Amount = 'amount',
  AuctionToken = 'auctionToken',
  Listing = 'listing',
  ListingId = 'listing__id',
  ListingTest = 'listing__test',
  ListingListingId = 'listing__listingId',
  ListingQuantity = 'listing__quantity',
  ListingStartTime = 'listing__startTime',
  ListingEndTime = 'listing__endTime',
  ListingType = 'listing__type',
  ListingStatus = 'listing__status',
  ListingHighestBidAmount = 'listing__highestBidAmount',
  ListingHighestBidToken = 'listing__highestBidToken',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
}

export interface BlockChangedFilter {
  number_gte: Scalars['Int'];
}

export interface Block_Height {
  hash?: Maybe<Scalars['Bytes']>;
  number?: Maybe<Scalars['Int']>;
  number_gte?: Maybe<Scalars['Int']>;
}

export interface Collection {
  __typename?: 'Collection';
  id: Scalars['ID'];
  tokenAddress: Scalars['Bytes'];
  totalSupply: Scalars['Int'];
  totalOwners: Scalars['Int'];
  commission?: Maybe<TokenCommission>;
}

export interface Collection_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  tokenAddress?: Maybe<Scalars['Bytes']>;
  tokenAddress_not?: Maybe<Scalars['Bytes']>;
  tokenAddress_gt?: Maybe<Scalars['Bytes']>;
  tokenAddress_lt?: Maybe<Scalars['Bytes']>;
  tokenAddress_gte?: Maybe<Scalars['Bytes']>;
  tokenAddress_lte?: Maybe<Scalars['Bytes']>;
  tokenAddress_in?: Maybe<Scalars['Bytes'][]>;
  tokenAddress_not_in?: Maybe<Scalars['Bytes'][]>;
  tokenAddress_contains?: Maybe<Scalars['Bytes']>;
  tokenAddress_not_contains?: Maybe<Scalars['Bytes']>;
  totalSupply?: Maybe<Scalars['Int']>;
  totalSupply_not?: Maybe<Scalars['Int']>;
  totalSupply_gt?: Maybe<Scalars['Int']>;
  totalSupply_lt?: Maybe<Scalars['Int']>;
  totalSupply_gte?: Maybe<Scalars['Int']>;
  totalSupply_lte?: Maybe<Scalars['Int']>;
  totalSupply_in?: Maybe<Scalars['Int'][]>;
  totalSupply_not_in?: Maybe<Scalars['Int'][]>;
  totalOwners?: Maybe<Scalars['Int']>;
  totalOwners_not?: Maybe<Scalars['Int']>;
  totalOwners_gt?: Maybe<Scalars['Int']>;
  totalOwners_lt?: Maybe<Scalars['Int']>;
  totalOwners_gte?: Maybe<Scalars['Int']>;
  totalOwners_lte?: Maybe<Scalars['Int']>;
  totalOwners_in?: Maybe<Scalars['Int'][]>;
  totalOwners_not_in?: Maybe<Scalars['Int'][]>;
  commission?: Maybe<Scalars['String']>;
  commission_not?: Maybe<Scalars['String']>;
  commission_gt?: Maybe<Scalars['String']>;
  commission_lt?: Maybe<Scalars['String']>;
  commission_gte?: Maybe<Scalars['String']>;
  commission_lte?: Maybe<Scalars['String']>;
  commission_in?: Maybe<Scalars['String'][]>;
  commission_not_in?: Maybe<Scalars['String'][]>;
  commission_contains?: Maybe<Scalars['String']>;
  commission_contains_nocase?: Maybe<Scalars['String']>;
  commission_not_contains?: Maybe<Scalars['String']>;
  commission_not_contains_nocase?: Maybe<Scalars['String']>;
  commission_starts_with?: Maybe<Scalars['String']>;
  commission_starts_with_nocase?: Maybe<Scalars['String']>;
  commission_not_starts_with?: Maybe<Scalars['String']>;
  commission_not_starts_with_nocase?: Maybe<Scalars['String']>;
  commission_ends_with?: Maybe<Scalars['String']>;
  commission_ends_with_nocase?: Maybe<Scalars['String']>;
  commission_not_ends_with?: Maybe<Scalars['String']>;
  commission_not_ends_with_nocase?: Maybe<Scalars['String']>;
  commission_?: Maybe<TokenCommission_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Collection_Filter>[]>;
  or?: Maybe<Maybe<Collection_Filter>[]>;
}

export enum Collection_OrderBy {
  Id = 'id',
  TokenAddress = 'tokenAddress',
  TotalSupply = 'totalSupply',
  TotalOwners = 'totalOwners',
  Commission = 'commission',
  CommissionId = 'commission__id',
  CommissionArtistAddress = 'commission__artistAddress',
  CommissionCommissionBasisPoint = 'commission__commissionBasisPoint',
}

export interface Listing {
  __typename?: 'Listing';
  id: Scalars['ID'];
  test?: Maybe<Scalars['Int']>;
  listingId: Scalars['BigInt'];
  seller: Account;
  asset: Asset;
  activeAsset?: Maybe<Asset>;
  quantity: Scalars['Int'];
  startTime: Scalars['Int'];
  endTime: Scalars['Int'];
  type: ListingType;
  status: ListingStatus;
  listingPrices?: Maybe<ListingPrice[]>;
  sale?: Maybe<Sale>;
  highestBidAmount?: Maybe<Scalars['BigInt']>;
  highestBidder?: Maybe<Account>;
  highestBidToken?: Maybe<Scalars['String']>;
  bids?: Maybe<Bid[]>;
}

export interface ListingListingPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ListingPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<ListingPrice_Filter>;
}

export interface ListingBidsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Bid_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Bid_Filter>;
}

export interface ListingPrice {
  __typename?: 'ListingPrice';
  id: Scalars['ID'];
  index: Scalars['Int'];
  listingToken: Scalars['String'];
  price: Scalars['BigInt'];
  listing: Listing;
  asset: Asset;
}

export interface ListingPrice_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  index?: Maybe<Scalars['Int']>;
  index_not?: Maybe<Scalars['Int']>;
  index_gt?: Maybe<Scalars['Int']>;
  index_lt?: Maybe<Scalars['Int']>;
  index_gte?: Maybe<Scalars['Int']>;
  index_lte?: Maybe<Scalars['Int']>;
  index_in?: Maybe<Scalars['Int'][]>;
  index_not_in?: Maybe<Scalars['Int'][]>;
  listingToken?: Maybe<Scalars['String']>;
  listingToken_not?: Maybe<Scalars['String']>;
  listingToken_gt?: Maybe<Scalars['String']>;
  listingToken_lt?: Maybe<Scalars['String']>;
  listingToken_gte?: Maybe<Scalars['String']>;
  listingToken_lte?: Maybe<Scalars['String']>;
  listingToken_in?: Maybe<Scalars['String'][]>;
  listingToken_not_in?: Maybe<Scalars['String'][]>;
  listingToken_contains?: Maybe<Scalars['String']>;
  listingToken_contains_nocase?: Maybe<Scalars['String']>;
  listingToken_not_contains?: Maybe<Scalars['String']>;
  listingToken_not_contains_nocase?: Maybe<Scalars['String']>;
  listingToken_starts_with?: Maybe<Scalars['String']>;
  listingToken_starts_with_nocase?: Maybe<Scalars['String']>;
  listingToken_not_starts_with?: Maybe<Scalars['String']>;
  listingToken_not_starts_with_nocase?: Maybe<Scalars['String']>;
  listingToken_ends_with?: Maybe<Scalars['String']>;
  listingToken_ends_with_nocase?: Maybe<Scalars['String']>;
  listingToken_not_ends_with?: Maybe<Scalars['String']>;
  listingToken_not_ends_with_nocase?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['BigInt']>;
  price_not?: Maybe<Scalars['BigInt']>;
  price_gt?: Maybe<Scalars['BigInt']>;
  price_lt?: Maybe<Scalars['BigInt']>;
  price_gte?: Maybe<Scalars['BigInt']>;
  price_lte?: Maybe<Scalars['BigInt']>;
  price_in?: Maybe<Scalars['BigInt'][]>;
  price_not_in?: Maybe<Scalars['BigInt'][]>;
  listing?: Maybe<Scalars['String']>;
  listing_not?: Maybe<Scalars['String']>;
  listing_gt?: Maybe<Scalars['String']>;
  listing_lt?: Maybe<Scalars['String']>;
  listing_gte?: Maybe<Scalars['String']>;
  listing_lte?: Maybe<Scalars['String']>;
  listing_in?: Maybe<Scalars['String'][]>;
  listing_not_in?: Maybe<Scalars['String'][]>;
  listing_contains?: Maybe<Scalars['String']>;
  listing_contains_nocase?: Maybe<Scalars['String']>;
  listing_not_contains?: Maybe<Scalars['String']>;
  listing_not_contains_nocase?: Maybe<Scalars['String']>;
  listing_starts_with?: Maybe<Scalars['String']>;
  listing_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_not_starts_with?: Maybe<Scalars['String']>;
  listing_not_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_ends_with?: Maybe<Scalars['String']>;
  listing_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_not_ends_with?: Maybe<Scalars['String']>;
  listing_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_?: Maybe<Listing_Filter>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<ListingPrice_Filter>[]>;
  or?: Maybe<Maybe<ListingPrice_Filter>[]>;
}

export enum ListingPrice_OrderBy {
  Id = 'id',
  Index = 'index',
  ListingToken = 'listingToken',
  Price = 'price',
  Listing = 'listing',
  ListingId = 'listing__id',
  ListingTest = 'listing__test',
  ListingListingId = 'listing__listingId',
  ListingQuantity = 'listing__quantity',
  ListingStartTime = 'listing__startTime',
  ListingEndTime = 'listing__endTime',
  ListingType = 'listing__type',
  ListingStatus = 'listing__status',
  ListingHighestBidAmount = 'listing__highestBidAmount',
  ListingHighestBidToken = 'listing__highestBidToken',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
}

export enum ListingStatus {
  Created = 'CREATED',
  Ended = 'ENDED',
  Cancelled = 'CANCELLED',
}

export enum ListingType {
  Listing = 'LISTING',
  Auction = 'AUCTION',
}

export interface Listing_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  test?: Maybe<Scalars['Int']>;
  test_not?: Maybe<Scalars['Int']>;
  test_gt?: Maybe<Scalars['Int']>;
  test_lt?: Maybe<Scalars['Int']>;
  test_gte?: Maybe<Scalars['Int']>;
  test_lte?: Maybe<Scalars['Int']>;
  test_in?: Maybe<Scalars['Int'][]>;
  test_not_in?: Maybe<Scalars['Int'][]>;
  listingId?: Maybe<Scalars['BigInt']>;
  listingId_not?: Maybe<Scalars['BigInt']>;
  listingId_gt?: Maybe<Scalars['BigInt']>;
  listingId_lt?: Maybe<Scalars['BigInt']>;
  listingId_gte?: Maybe<Scalars['BigInt']>;
  listingId_lte?: Maybe<Scalars['BigInt']>;
  listingId_in?: Maybe<Scalars['BigInt'][]>;
  listingId_not_in?: Maybe<Scalars['BigInt'][]>;
  seller?: Maybe<Scalars['String']>;
  seller_not?: Maybe<Scalars['String']>;
  seller_gt?: Maybe<Scalars['String']>;
  seller_lt?: Maybe<Scalars['String']>;
  seller_gte?: Maybe<Scalars['String']>;
  seller_lte?: Maybe<Scalars['String']>;
  seller_in?: Maybe<Scalars['String'][]>;
  seller_not_in?: Maybe<Scalars['String'][]>;
  seller_contains?: Maybe<Scalars['String']>;
  seller_contains_nocase?: Maybe<Scalars['String']>;
  seller_not_contains?: Maybe<Scalars['String']>;
  seller_not_contains_nocase?: Maybe<Scalars['String']>;
  seller_starts_with?: Maybe<Scalars['String']>;
  seller_starts_with_nocase?: Maybe<Scalars['String']>;
  seller_not_starts_with?: Maybe<Scalars['String']>;
  seller_not_starts_with_nocase?: Maybe<Scalars['String']>;
  seller_ends_with?: Maybe<Scalars['String']>;
  seller_ends_with_nocase?: Maybe<Scalars['String']>;
  seller_not_ends_with?: Maybe<Scalars['String']>;
  seller_not_ends_with_nocase?: Maybe<Scalars['String']>;
  seller_?: Maybe<Account_Filter>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  activeAsset?: Maybe<Scalars['String']>;
  activeAsset_not?: Maybe<Scalars['String']>;
  activeAsset_gt?: Maybe<Scalars['String']>;
  activeAsset_lt?: Maybe<Scalars['String']>;
  activeAsset_gte?: Maybe<Scalars['String']>;
  activeAsset_lte?: Maybe<Scalars['String']>;
  activeAsset_in?: Maybe<Scalars['String'][]>;
  activeAsset_not_in?: Maybe<Scalars['String'][]>;
  activeAsset_contains?: Maybe<Scalars['String']>;
  activeAsset_contains_nocase?: Maybe<Scalars['String']>;
  activeAsset_not_contains?: Maybe<Scalars['String']>;
  activeAsset_not_contains_nocase?: Maybe<Scalars['String']>;
  activeAsset_starts_with?: Maybe<Scalars['String']>;
  activeAsset_starts_with_nocase?: Maybe<Scalars['String']>;
  activeAsset_not_starts_with?: Maybe<Scalars['String']>;
  activeAsset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  activeAsset_ends_with?: Maybe<Scalars['String']>;
  activeAsset_ends_with_nocase?: Maybe<Scalars['String']>;
  activeAsset_not_ends_with?: Maybe<Scalars['String']>;
  activeAsset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  activeAsset_?: Maybe<Asset_Filter>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_not?: Maybe<Scalars['Int']>;
  quantity_gt?: Maybe<Scalars['Int']>;
  quantity_lt?: Maybe<Scalars['Int']>;
  quantity_gte?: Maybe<Scalars['Int']>;
  quantity_lte?: Maybe<Scalars['Int']>;
  quantity_in?: Maybe<Scalars['Int'][]>;
  quantity_not_in?: Maybe<Scalars['Int'][]>;
  startTime?: Maybe<Scalars['Int']>;
  startTime_not?: Maybe<Scalars['Int']>;
  startTime_gt?: Maybe<Scalars['Int']>;
  startTime_lt?: Maybe<Scalars['Int']>;
  startTime_gte?: Maybe<Scalars['Int']>;
  startTime_lte?: Maybe<Scalars['Int']>;
  startTime_in?: Maybe<Scalars['Int'][]>;
  startTime_not_in?: Maybe<Scalars['Int'][]>;
  endTime?: Maybe<Scalars['Int']>;
  endTime_not?: Maybe<Scalars['Int']>;
  endTime_gt?: Maybe<Scalars['Int']>;
  endTime_lt?: Maybe<Scalars['Int']>;
  endTime_gte?: Maybe<Scalars['Int']>;
  endTime_lte?: Maybe<Scalars['Int']>;
  endTime_in?: Maybe<Scalars['Int'][]>;
  endTime_not_in?: Maybe<Scalars['Int'][]>;
  type?: Maybe<ListingType>;
  type_not?: Maybe<ListingType>;
  type_in?: Maybe<ListingType[]>;
  type_not_in?: Maybe<ListingType[]>;
  status?: Maybe<ListingStatus>;
  status_not?: Maybe<ListingStatus>;
  status_in?: Maybe<ListingStatus[]>;
  status_not_in?: Maybe<ListingStatus[]>;
  listingPrices_?: Maybe<ListingPrice_Filter>;
  sale?: Maybe<Scalars['String']>;
  sale_not?: Maybe<Scalars['String']>;
  sale_gt?: Maybe<Scalars['String']>;
  sale_lt?: Maybe<Scalars['String']>;
  sale_gte?: Maybe<Scalars['String']>;
  sale_lte?: Maybe<Scalars['String']>;
  sale_in?: Maybe<Scalars['String'][]>;
  sale_not_in?: Maybe<Scalars['String'][]>;
  sale_contains?: Maybe<Scalars['String']>;
  sale_contains_nocase?: Maybe<Scalars['String']>;
  sale_not_contains?: Maybe<Scalars['String']>;
  sale_not_contains_nocase?: Maybe<Scalars['String']>;
  sale_starts_with?: Maybe<Scalars['String']>;
  sale_starts_with_nocase?: Maybe<Scalars['String']>;
  sale_not_starts_with?: Maybe<Scalars['String']>;
  sale_not_starts_with_nocase?: Maybe<Scalars['String']>;
  sale_ends_with?: Maybe<Scalars['String']>;
  sale_ends_with_nocase?: Maybe<Scalars['String']>;
  sale_not_ends_with?: Maybe<Scalars['String']>;
  sale_not_ends_with_nocase?: Maybe<Scalars['String']>;
  sale_?: Maybe<Sale_Filter>;
  highestBidAmount?: Maybe<Scalars['BigInt']>;
  highestBidAmount_not?: Maybe<Scalars['BigInt']>;
  highestBidAmount_gt?: Maybe<Scalars['BigInt']>;
  highestBidAmount_lt?: Maybe<Scalars['BigInt']>;
  highestBidAmount_gte?: Maybe<Scalars['BigInt']>;
  highestBidAmount_lte?: Maybe<Scalars['BigInt']>;
  highestBidAmount_in?: Maybe<Scalars['BigInt'][]>;
  highestBidAmount_not_in?: Maybe<Scalars['BigInt'][]>;
  highestBidder?: Maybe<Scalars['String']>;
  highestBidder_not?: Maybe<Scalars['String']>;
  highestBidder_gt?: Maybe<Scalars['String']>;
  highestBidder_lt?: Maybe<Scalars['String']>;
  highestBidder_gte?: Maybe<Scalars['String']>;
  highestBidder_lte?: Maybe<Scalars['String']>;
  highestBidder_in?: Maybe<Scalars['String'][]>;
  highestBidder_not_in?: Maybe<Scalars['String'][]>;
  highestBidder_contains?: Maybe<Scalars['String']>;
  highestBidder_contains_nocase?: Maybe<Scalars['String']>;
  highestBidder_not_contains?: Maybe<Scalars['String']>;
  highestBidder_not_contains_nocase?: Maybe<Scalars['String']>;
  highestBidder_starts_with?: Maybe<Scalars['String']>;
  highestBidder_starts_with_nocase?: Maybe<Scalars['String']>;
  highestBidder_not_starts_with?: Maybe<Scalars['String']>;
  highestBidder_not_starts_with_nocase?: Maybe<Scalars['String']>;
  highestBidder_ends_with?: Maybe<Scalars['String']>;
  highestBidder_ends_with_nocase?: Maybe<Scalars['String']>;
  highestBidder_not_ends_with?: Maybe<Scalars['String']>;
  highestBidder_not_ends_with_nocase?: Maybe<Scalars['String']>;
  highestBidder_?: Maybe<Account_Filter>;
  highestBidToken?: Maybe<Scalars['String']>;
  highestBidToken_not?: Maybe<Scalars['String']>;
  highestBidToken_gt?: Maybe<Scalars['String']>;
  highestBidToken_lt?: Maybe<Scalars['String']>;
  highestBidToken_gte?: Maybe<Scalars['String']>;
  highestBidToken_lte?: Maybe<Scalars['String']>;
  highestBidToken_in?: Maybe<Scalars['String'][]>;
  highestBidToken_not_in?: Maybe<Scalars['String'][]>;
  highestBidToken_contains?: Maybe<Scalars['String']>;
  highestBidToken_contains_nocase?: Maybe<Scalars['String']>;
  highestBidToken_not_contains?: Maybe<Scalars['String']>;
  highestBidToken_not_contains_nocase?: Maybe<Scalars['String']>;
  highestBidToken_starts_with?: Maybe<Scalars['String']>;
  highestBidToken_starts_with_nocase?: Maybe<Scalars['String']>;
  highestBidToken_not_starts_with?: Maybe<Scalars['String']>;
  highestBidToken_not_starts_with_nocase?: Maybe<Scalars['String']>;
  highestBidToken_ends_with?: Maybe<Scalars['String']>;
  highestBidToken_ends_with_nocase?: Maybe<Scalars['String']>;
  highestBidToken_not_ends_with?: Maybe<Scalars['String']>;
  highestBidToken_not_ends_with_nocase?: Maybe<Scalars['String']>;
  bids_?: Maybe<Bid_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Listing_Filter>[]>;
  or?: Maybe<Maybe<Listing_Filter>[]>;
}

export enum Listing_OrderBy {
  Id = 'id',
  Test = 'test',
  ListingId = 'listingId',
  Seller = 'seller',
  SellerId = 'seller__id',
  SellerAddress = 'seller__address',
  SellerNumAssets = 'seller__numAssets',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
  ActiveAsset = 'activeAsset',
  ActiveAssetId = 'activeAsset__id',
  ActiveAssetTokenId = 'activeAsset__tokenId',
  ActiveAssetTokenAddress = 'activeAsset__tokenAddress',
  ActiveAssetTotalSupply = 'activeAsset__totalSupply',
  ActiveAssetType = 'activeAsset__type',
  ActiveAssetUri = 'activeAsset__uri',
  ActiveAssetTitle = 'activeAsset__title',
  ActiveAssetSearchTitle = 'activeAsset__searchTitle',
  ActiveAssetDescription = 'activeAsset__description',
  ActiveAssetSearchDescription = 'activeAsset__searchDescription',
  ActiveAssetImage = 'activeAsset__image',
  ActiveAssetAnimationUrl = 'activeAsset__animation_url',
  ActiveAssetDisplayTime = 'activeAsset__displayTime',
  ActiveAssetNativePrice = 'activeAsset__nativePrice',
  ActiveAssetMogulPrice = 'activeAsset__mogulPrice',
  ActiveAssetMintedTime = 'activeAsset__mintedTime',
  ActiveAssetNumOwners = 'activeAsset__numOwners',
  ActiveAssetActiveListingsLength = 'activeAsset__activeListingsLength',
  Quantity = 'quantity',
  StartTime = 'startTime',
  EndTime = 'endTime',
  Type = 'type',
  Status = 'status',
  ListingPrices = 'listingPrices',
  Sale = 'sale',
  SaleId = 'sale__id',
  SaleAmount = 'sale__amount',
  SaleQuantity = 'sale__quantity',
  SaleAuctionToken = 'sale__auctionToken',
  HighestBidAmount = 'highestBidAmount',
  HighestBidder = 'highestBidder',
  HighestBidderId = 'highestBidder__id',
  HighestBidderAddress = 'highestBidder__address',
  HighestBidderNumAssets = 'highestBidder__numAssets',
  HighestBidToken = 'highestBidToken',
  Bids = 'bids',
}

export interface MogiesPurchase {
  __typename?: 'MogiesPurchase';
  id: Scalars['ID'];
  wallet: Scalars['Bytes'];
  quantity: Scalars['Int'];
  starsPrice: Scalars['BigInt'];
  ethPrice: Scalars['BigInt'];
  timestamp: Scalars['BigInt'];
}

export interface MogiesPurchase_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  wallet?: Maybe<Scalars['Bytes']>;
  wallet_not?: Maybe<Scalars['Bytes']>;
  wallet_gt?: Maybe<Scalars['Bytes']>;
  wallet_lt?: Maybe<Scalars['Bytes']>;
  wallet_gte?: Maybe<Scalars['Bytes']>;
  wallet_lte?: Maybe<Scalars['Bytes']>;
  wallet_in?: Maybe<Scalars['Bytes'][]>;
  wallet_not_in?: Maybe<Scalars['Bytes'][]>;
  wallet_contains?: Maybe<Scalars['Bytes']>;
  wallet_not_contains?: Maybe<Scalars['Bytes']>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_not?: Maybe<Scalars['Int']>;
  quantity_gt?: Maybe<Scalars['Int']>;
  quantity_lt?: Maybe<Scalars['Int']>;
  quantity_gte?: Maybe<Scalars['Int']>;
  quantity_lte?: Maybe<Scalars['Int']>;
  quantity_in?: Maybe<Scalars['Int'][]>;
  quantity_not_in?: Maybe<Scalars['Int'][]>;
  starsPrice?: Maybe<Scalars['BigInt']>;
  starsPrice_not?: Maybe<Scalars['BigInt']>;
  starsPrice_gt?: Maybe<Scalars['BigInt']>;
  starsPrice_lt?: Maybe<Scalars['BigInt']>;
  starsPrice_gte?: Maybe<Scalars['BigInt']>;
  starsPrice_lte?: Maybe<Scalars['BigInt']>;
  starsPrice_in?: Maybe<Scalars['BigInt'][]>;
  starsPrice_not_in?: Maybe<Scalars['BigInt'][]>;
  ethPrice?: Maybe<Scalars['BigInt']>;
  ethPrice_not?: Maybe<Scalars['BigInt']>;
  ethPrice_gt?: Maybe<Scalars['BigInt']>;
  ethPrice_lt?: Maybe<Scalars['BigInt']>;
  ethPrice_gte?: Maybe<Scalars['BigInt']>;
  ethPrice_lte?: Maybe<Scalars['BigInt']>;
  ethPrice_in?: Maybe<Scalars['BigInt'][]>;
  ethPrice_not_in?: Maybe<Scalars['BigInt'][]>;
  timestamp?: Maybe<Scalars['BigInt']>;
  timestamp_not?: Maybe<Scalars['BigInt']>;
  timestamp_gt?: Maybe<Scalars['BigInt']>;
  timestamp_lt?: Maybe<Scalars['BigInt']>;
  timestamp_gte?: Maybe<Scalars['BigInt']>;
  timestamp_lte?: Maybe<Scalars['BigInt']>;
  timestamp_in?: Maybe<Scalars['BigInt'][]>;
  timestamp_not_in?: Maybe<Scalars['BigInt'][]>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<MogiesPurchase_Filter>[]>;
  or?: Maybe<Maybe<MogiesPurchase_Filter>[]>;
}

export enum MogiesPurchase_OrderBy {
  Id = 'id',
  Wallet = 'wallet',
  Quantity = 'quantity',
  StarsPrice = 'starsPrice',
  EthPrice = 'ethPrice',
  Timestamp = 'timestamp',
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface Query {
  __typename?: 'Query';
  bid?: Maybe<Bid>;
  bids: Bid[];
  listingPrice?: Maybe<ListingPrice>;
  listingPrices: ListingPrice[];
  listing?: Maybe<Listing>;
  listings: Listing[];
  sale?: Maybe<Sale>;
  sales: Sale[];
  collection?: Maybe<Collection>;
  collections: Collection[];
  asset?: Maybe<Asset>;
  assets: Asset[];
  tokenPrice?: Maybe<TokenPrice>;
  tokenPrices: TokenPrice[];
  accountAsset?: Maybe<AccountAsset>;
  accountAssets: AccountAsset[];
  accountCollection?: Maybe<AccountCollection>;
  accountCollections: AccountCollection[];
  account?: Maybe<Account>;
  accounts: Account[];
  assetHistory?: Maybe<AssetHistory>;
  assetHistories: AssetHistory[];
  transfer?: Maybe<Transfer>;
  transfers: Transfer[];
  tokenCommission?: Maybe<TokenCommission>;
  tokenCommissions: TokenCommission[];
  mogiesPurchase?: Maybe<MogiesPurchase>;
  mogiesPurchases: MogiesPurchase[];
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
}

export interface QueryBidArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryBidsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Bid_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Bid_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryListingPriceArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryListingPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ListingPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<ListingPrice_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryListingArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryListingsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Listing_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Listing_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QuerySaleArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QuerySalesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Sale_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Sale_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryCollectionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryCollectionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Collection_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Collection_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAssetArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Asset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Asset_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTokenPriceArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTokenPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TokenPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<TokenPrice_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountAssetArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountAsset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountAsset_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountCollectionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountCollectionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountCollection_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountCollection_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAccountsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Account_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Account_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAssetHistoryArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryAssetHistoriesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AssetHistory_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AssetHistory_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTransferArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTransfersArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Transfer_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Transfer_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTokenCommissionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryTokenCommissionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TokenCommission_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<TokenCommission_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryMogiesPurchaseArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface QueryMogiesPurchasesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<MogiesPurchase_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<MogiesPurchase_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface Query_MetaArgs {
  block?: Maybe<Block_Height>;
}

export interface Sale {
  __typename?: 'Sale';
  id: Scalars['ID'];
  buyer: Account;
  amount: Scalars['BigInt'];
  quantity: Scalars['Int'];
  auctionToken: Scalars['String'];
  listing: Listing;
}

export interface Sale_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  buyer?: Maybe<Scalars['String']>;
  buyer_not?: Maybe<Scalars['String']>;
  buyer_gt?: Maybe<Scalars['String']>;
  buyer_lt?: Maybe<Scalars['String']>;
  buyer_gte?: Maybe<Scalars['String']>;
  buyer_lte?: Maybe<Scalars['String']>;
  buyer_in?: Maybe<Scalars['String'][]>;
  buyer_not_in?: Maybe<Scalars['String'][]>;
  buyer_contains?: Maybe<Scalars['String']>;
  buyer_contains_nocase?: Maybe<Scalars['String']>;
  buyer_not_contains?: Maybe<Scalars['String']>;
  buyer_not_contains_nocase?: Maybe<Scalars['String']>;
  buyer_starts_with?: Maybe<Scalars['String']>;
  buyer_starts_with_nocase?: Maybe<Scalars['String']>;
  buyer_not_starts_with?: Maybe<Scalars['String']>;
  buyer_not_starts_with_nocase?: Maybe<Scalars['String']>;
  buyer_ends_with?: Maybe<Scalars['String']>;
  buyer_ends_with_nocase?: Maybe<Scalars['String']>;
  buyer_not_ends_with?: Maybe<Scalars['String']>;
  buyer_not_ends_with_nocase?: Maybe<Scalars['String']>;
  buyer_?: Maybe<Account_Filter>;
  amount?: Maybe<Scalars['BigInt']>;
  amount_not?: Maybe<Scalars['BigInt']>;
  amount_gt?: Maybe<Scalars['BigInt']>;
  amount_lt?: Maybe<Scalars['BigInt']>;
  amount_gte?: Maybe<Scalars['BigInt']>;
  amount_lte?: Maybe<Scalars['BigInt']>;
  amount_in?: Maybe<Scalars['BigInt'][]>;
  amount_not_in?: Maybe<Scalars['BigInt'][]>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_not?: Maybe<Scalars['Int']>;
  quantity_gt?: Maybe<Scalars['Int']>;
  quantity_lt?: Maybe<Scalars['Int']>;
  quantity_gte?: Maybe<Scalars['Int']>;
  quantity_lte?: Maybe<Scalars['Int']>;
  quantity_in?: Maybe<Scalars['Int'][]>;
  quantity_not_in?: Maybe<Scalars['Int'][]>;
  auctionToken?: Maybe<Scalars['String']>;
  auctionToken_not?: Maybe<Scalars['String']>;
  auctionToken_gt?: Maybe<Scalars['String']>;
  auctionToken_lt?: Maybe<Scalars['String']>;
  auctionToken_gte?: Maybe<Scalars['String']>;
  auctionToken_lte?: Maybe<Scalars['String']>;
  auctionToken_in?: Maybe<Scalars['String'][]>;
  auctionToken_not_in?: Maybe<Scalars['String'][]>;
  auctionToken_contains?: Maybe<Scalars['String']>;
  auctionToken_contains_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_contains?: Maybe<Scalars['String']>;
  auctionToken_not_contains_nocase?: Maybe<Scalars['String']>;
  auctionToken_starts_with?: Maybe<Scalars['String']>;
  auctionToken_starts_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_starts_with?: Maybe<Scalars['String']>;
  auctionToken_not_starts_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_ends_with?: Maybe<Scalars['String']>;
  auctionToken_ends_with_nocase?: Maybe<Scalars['String']>;
  auctionToken_not_ends_with?: Maybe<Scalars['String']>;
  auctionToken_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing?: Maybe<Scalars['String']>;
  listing_not?: Maybe<Scalars['String']>;
  listing_gt?: Maybe<Scalars['String']>;
  listing_lt?: Maybe<Scalars['String']>;
  listing_gte?: Maybe<Scalars['String']>;
  listing_lte?: Maybe<Scalars['String']>;
  listing_in?: Maybe<Scalars['String'][]>;
  listing_not_in?: Maybe<Scalars['String'][]>;
  listing_contains?: Maybe<Scalars['String']>;
  listing_contains_nocase?: Maybe<Scalars['String']>;
  listing_not_contains?: Maybe<Scalars['String']>;
  listing_not_contains_nocase?: Maybe<Scalars['String']>;
  listing_starts_with?: Maybe<Scalars['String']>;
  listing_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_not_starts_with?: Maybe<Scalars['String']>;
  listing_not_starts_with_nocase?: Maybe<Scalars['String']>;
  listing_ends_with?: Maybe<Scalars['String']>;
  listing_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_not_ends_with?: Maybe<Scalars['String']>;
  listing_not_ends_with_nocase?: Maybe<Scalars['String']>;
  listing_?: Maybe<Listing_Filter>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Sale_Filter>[]>;
  or?: Maybe<Maybe<Sale_Filter>[]>;
}

export enum Sale_OrderBy {
  Id = 'id',
  Buyer = 'buyer',
  BuyerId = 'buyer__id',
  BuyerAddress = 'buyer__address',
  BuyerNumAssets = 'buyer__numAssets',
  Amount = 'amount',
  Quantity = 'quantity',
  AuctionToken = 'auctionToken',
  Listing = 'listing',
  ListingId = 'listing__id',
  ListingTest = 'listing__test',
  ListingListingId = 'listing__listingId',
  ListingQuantity = 'listing__quantity',
  ListingStartTime = 'listing__startTime',
  ListingEndTime = 'listing__endTime',
  ListingType = 'listing__type',
  ListingStatus = 'listing__status',
  ListingHighestBidAmount = 'listing__highestBidAmount',
  ListingHighestBidToken = 'listing__highestBidToken',
}

export interface Subscription {
  __typename?: 'Subscription';
  bid?: Maybe<Bid>;
  bids: Bid[];
  listingPrice?: Maybe<ListingPrice>;
  listingPrices: ListingPrice[];
  listing?: Maybe<Listing>;
  listings: Listing[];
  sale?: Maybe<Sale>;
  sales: Sale[];
  collection?: Maybe<Collection>;
  collections: Collection[];
  asset?: Maybe<Asset>;
  assets: Asset[];
  tokenPrice?: Maybe<TokenPrice>;
  tokenPrices: TokenPrice[];
  accountAsset?: Maybe<AccountAsset>;
  accountAssets: AccountAsset[];
  accountCollection?: Maybe<AccountCollection>;
  accountCollections: AccountCollection[];
  account?: Maybe<Account>;
  accounts: Account[];
  assetHistory?: Maybe<AssetHistory>;
  assetHistories: AssetHistory[];
  transfer?: Maybe<Transfer>;
  transfers: Transfer[];
  tokenCommission?: Maybe<TokenCommission>;
  tokenCommissions: TokenCommission[];
  mogiesPurchase?: Maybe<MogiesPurchase>;
  mogiesPurchases: MogiesPurchase[];
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
}

export interface SubscriptionBidArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionBidsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Bid_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Bid_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionListingPriceArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionListingPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<ListingPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<ListingPrice_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionListingArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionListingsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Listing_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Listing_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionSaleArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionSalesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Sale_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Sale_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionCollectionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionCollectionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Collection_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Collection_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAssetArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Asset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Asset_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTokenPriceArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTokenPricesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TokenPrice_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<TokenPrice_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountAssetArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountAssetsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountAsset_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountAsset_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountCollectionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountCollectionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AccountCollection_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AccountCollection_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAccountsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Account_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Account_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAssetHistoryArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionAssetHistoriesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<AssetHistory_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<AssetHistory_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTransferArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTransfersArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Transfer_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<Transfer_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTokenCommissionArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionTokenCommissionsArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<TokenCommission_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<TokenCommission_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionMogiesPurchaseArgs {
  id: Scalars['ID'];
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface SubscriptionMogiesPurchasesArgs {
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<MogiesPurchase_OrderBy>;
  orderDirection?: Maybe<OrderDirection>;
  where?: Maybe<MogiesPurchase_Filter>;
  block?: Maybe<Block_Height>;
  subgraphError?: _SubgraphErrorPolicy_;
}

export interface Subscription_MetaArgs {
  block?: Maybe<Block_Height>;
}

export interface TokenCommission {
  __typename?: 'TokenCommission';
  id: Scalars['ID'];
  artistAddress: Scalars['Bytes'];
  commissionBasisPoint: Scalars['Int'];
}

export interface TokenCommission_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  artistAddress?: Maybe<Scalars['Bytes']>;
  artistAddress_not?: Maybe<Scalars['Bytes']>;
  artistAddress_gt?: Maybe<Scalars['Bytes']>;
  artistAddress_lt?: Maybe<Scalars['Bytes']>;
  artistAddress_gte?: Maybe<Scalars['Bytes']>;
  artistAddress_lte?: Maybe<Scalars['Bytes']>;
  artistAddress_in?: Maybe<Scalars['Bytes'][]>;
  artistAddress_not_in?: Maybe<Scalars['Bytes'][]>;
  artistAddress_contains?: Maybe<Scalars['Bytes']>;
  artistAddress_not_contains?: Maybe<Scalars['Bytes']>;
  commissionBasisPoint?: Maybe<Scalars['Int']>;
  commissionBasisPoint_not?: Maybe<Scalars['Int']>;
  commissionBasisPoint_gt?: Maybe<Scalars['Int']>;
  commissionBasisPoint_lt?: Maybe<Scalars['Int']>;
  commissionBasisPoint_gte?: Maybe<Scalars['Int']>;
  commissionBasisPoint_lte?: Maybe<Scalars['Int']>;
  commissionBasisPoint_in?: Maybe<Scalars['Int'][]>;
  commissionBasisPoint_not_in?: Maybe<Scalars['Int'][]>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<TokenCommission_Filter>[]>;
  or?: Maybe<Maybe<TokenCommission_Filter>[]>;
}

export enum TokenCommission_OrderBy {
  Id = 'id',
  ArtistAddress = 'artistAddress',
  CommissionBasisPoint = 'commissionBasisPoint',
}

export interface TokenPrice {
  __typename?: 'TokenPrice';
  id: Scalars['ID'];
  price: Scalars['BigInt'];
  tokenAddress: Scalars['String'];
}

export interface TokenPrice_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  price?: Maybe<Scalars['BigInt']>;
  price_not?: Maybe<Scalars['BigInt']>;
  price_gt?: Maybe<Scalars['BigInt']>;
  price_lt?: Maybe<Scalars['BigInt']>;
  price_gte?: Maybe<Scalars['BigInt']>;
  price_lte?: Maybe<Scalars['BigInt']>;
  price_in?: Maybe<Scalars['BigInt'][]>;
  price_not_in?: Maybe<Scalars['BigInt'][]>;
  tokenAddress?: Maybe<Scalars['String']>;
  tokenAddress_not?: Maybe<Scalars['String']>;
  tokenAddress_gt?: Maybe<Scalars['String']>;
  tokenAddress_lt?: Maybe<Scalars['String']>;
  tokenAddress_gte?: Maybe<Scalars['String']>;
  tokenAddress_lte?: Maybe<Scalars['String']>;
  tokenAddress_in?: Maybe<Scalars['String'][]>;
  tokenAddress_not_in?: Maybe<Scalars['String'][]>;
  tokenAddress_contains?: Maybe<Scalars['String']>;
  tokenAddress_contains_nocase?: Maybe<Scalars['String']>;
  tokenAddress_not_contains?: Maybe<Scalars['String']>;
  tokenAddress_not_contains_nocase?: Maybe<Scalars['String']>;
  tokenAddress_starts_with?: Maybe<Scalars['String']>;
  tokenAddress_starts_with_nocase?: Maybe<Scalars['String']>;
  tokenAddress_not_starts_with?: Maybe<Scalars['String']>;
  tokenAddress_not_starts_with_nocase?: Maybe<Scalars['String']>;
  tokenAddress_ends_with?: Maybe<Scalars['String']>;
  tokenAddress_ends_with_nocase?: Maybe<Scalars['String']>;
  tokenAddress_not_ends_with?: Maybe<Scalars['String']>;
  tokenAddress_not_ends_with_nocase?: Maybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<TokenPrice_Filter>[]>;
  or?: Maybe<Maybe<TokenPrice_Filter>[]>;
}

export enum TokenPrice_OrderBy {
  Id = 'id',
  Price = 'price',
  TokenAddress = 'tokenAddress',
}

export enum TokenSymbol {
  Stars = 'STARS',
  Eth = 'ETH',
}

export interface Transfer {
  __typename?: 'Transfer';
  id: Scalars['ID'];
  hash: Scalars['Bytes'];
  asset: Asset;
  to: Account;
  from: Account;
  quantity: Scalars['Int'];
}

export interface Transfer_Filter {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_lt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Scalars['ID'][]>;
  id_not_in?: Maybe<Scalars['ID'][]>;
  hash?: Maybe<Scalars['Bytes']>;
  hash_not?: Maybe<Scalars['Bytes']>;
  hash_gt?: Maybe<Scalars['Bytes']>;
  hash_lt?: Maybe<Scalars['Bytes']>;
  hash_gte?: Maybe<Scalars['Bytes']>;
  hash_lte?: Maybe<Scalars['Bytes']>;
  hash_in?: Maybe<Scalars['Bytes'][]>;
  hash_not_in?: Maybe<Scalars['Bytes'][]>;
  hash_contains?: Maybe<Scalars['Bytes']>;
  hash_not_contains?: Maybe<Scalars['Bytes']>;
  asset?: Maybe<Scalars['String']>;
  asset_not?: Maybe<Scalars['String']>;
  asset_gt?: Maybe<Scalars['String']>;
  asset_lt?: Maybe<Scalars['String']>;
  asset_gte?: Maybe<Scalars['String']>;
  asset_lte?: Maybe<Scalars['String']>;
  asset_in?: Maybe<Scalars['String'][]>;
  asset_not_in?: Maybe<Scalars['String'][]>;
  asset_contains?: Maybe<Scalars['String']>;
  asset_contains_nocase?: Maybe<Scalars['String']>;
  asset_not_contains?: Maybe<Scalars['String']>;
  asset_not_contains_nocase?: Maybe<Scalars['String']>;
  asset_starts_with?: Maybe<Scalars['String']>;
  asset_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_not_starts_with?: Maybe<Scalars['String']>;
  asset_not_starts_with_nocase?: Maybe<Scalars['String']>;
  asset_ends_with?: Maybe<Scalars['String']>;
  asset_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_not_ends_with?: Maybe<Scalars['String']>;
  asset_not_ends_with_nocase?: Maybe<Scalars['String']>;
  asset_?: Maybe<Asset_Filter>;
  to?: Maybe<Scalars['String']>;
  to_not?: Maybe<Scalars['String']>;
  to_gt?: Maybe<Scalars['String']>;
  to_lt?: Maybe<Scalars['String']>;
  to_gte?: Maybe<Scalars['String']>;
  to_lte?: Maybe<Scalars['String']>;
  to_in?: Maybe<Scalars['String'][]>;
  to_not_in?: Maybe<Scalars['String'][]>;
  to_contains?: Maybe<Scalars['String']>;
  to_contains_nocase?: Maybe<Scalars['String']>;
  to_not_contains?: Maybe<Scalars['String']>;
  to_not_contains_nocase?: Maybe<Scalars['String']>;
  to_starts_with?: Maybe<Scalars['String']>;
  to_starts_with_nocase?: Maybe<Scalars['String']>;
  to_not_starts_with?: Maybe<Scalars['String']>;
  to_not_starts_with_nocase?: Maybe<Scalars['String']>;
  to_ends_with?: Maybe<Scalars['String']>;
  to_ends_with_nocase?: Maybe<Scalars['String']>;
  to_not_ends_with?: Maybe<Scalars['String']>;
  to_not_ends_with_nocase?: Maybe<Scalars['String']>;
  to_?: Maybe<Account_Filter>;
  from?: Maybe<Scalars['String']>;
  from_not?: Maybe<Scalars['String']>;
  from_gt?: Maybe<Scalars['String']>;
  from_lt?: Maybe<Scalars['String']>;
  from_gte?: Maybe<Scalars['String']>;
  from_lte?: Maybe<Scalars['String']>;
  from_in?: Maybe<Scalars['String'][]>;
  from_not_in?: Maybe<Scalars['String'][]>;
  from_contains?: Maybe<Scalars['String']>;
  from_contains_nocase?: Maybe<Scalars['String']>;
  from_not_contains?: Maybe<Scalars['String']>;
  from_not_contains_nocase?: Maybe<Scalars['String']>;
  from_starts_with?: Maybe<Scalars['String']>;
  from_starts_with_nocase?: Maybe<Scalars['String']>;
  from_not_starts_with?: Maybe<Scalars['String']>;
  from_not_starts_with_nocase?: Maybe<Scalars['String']>;
  from_ends_with?: Maybe<Scalars['String']>;
  from_ends_with_nocase?: Maybe<Scalars['String']>;
  from_not_ends_with?: Maybe<Scalars['String']>;
  from_not_ends_with_nocase?: Maybe<Scalars['String']>;
  from_?: Maybe<Account_Filter>;
  quantity?: Maybe<Scalars['Int']>;
  quantity_not?: Maybe<Scalars['Int']>;
  quantity_gt?: Maybe<Scalars['Int']>;
  quantity_lt?: Maybe<Scalars['Int']>;
  quantity_gte?: Maybe<Scalars['Int']>;
  quantity_lte?: Maybe<Scalars['Int']>;
  quantity_in?: Maybe<Scalars['Int'][]>;
  quantity_not_in?: Maybe<Scalars['Int'][]>;
  /** Filter for the block changed event. */
  _change_block?: Maybe<BlockChangedFilter>;
  and?: Maybe<Maybe<Transfer_Filter>[]>;
  or?: Maybe<Maybe<Transfer_Filter>[]>;
}

export enum Transfer_OrderBy {
  Id = 'id',
  Hash = 'hash',
  Asset = 'asset',
  AssetId = 'asset__id',
  AssetTokenId = 'asset__tokenId',
  AssetTokenAddress = 'asset__tokenAddress',
  AssetTotalSupply = 'asset__totalSupply',
  AssetType = 'asset__type',
  AssetUri = 'asset__uri',
  AssetTitle = 'asset__title',
  AssetSearchTitle = 'asset__searchTitle',
  AssetDescription = 'asset__description',
  AssetSearchDescription = 'asset__searchDescription',
  AssetImage = 'asset__image',
  AssetAnimationUrl = 'asset__animation_url',
  AssetDisplayTime = 'asset__displayTime',
  AssetNativePrice = 'asset__nativePrice',
  AssetMogulPrice = 'asset__mogulPrice',
  AssetMintedTime = 'asset__mintedTime',
  AssetNumOwners = 'asset__numOwners',
  AssetActiveListingsLength = 'asset__activeListingsLength',
  To = 'to',
  ToId = 'to__id',
  ToAddress = 'to__address',
  ToNumAssets = 'to__numAssets',
  From = 'from',
  FromId = 'from__id',
  FromAddress = 'from__address',
  FromNumAssets = 'from__numAssets',
  Quantity = 'quantity',
}

export interface _Block_ {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']>;
}

/** The type for the top-level _meta field */
export interface _Meta_ {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
}

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny',
}
